import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar'; 
import Footer from './components/Footer'; 
import Home from './pages/Home.js';
import Team from './pages/Team.js';
import Projects from './pages/Projects.js';
import AddProject from './pages/admin/AddProject';
import Resources from './pages/resources/Resources.js';
import GPACalculator from './pages/resources/GPACalculator.js';
import QuantClub from './pages/quantClub/QuantClub.js';
import Contact from './pages/Contact.js';
import ProjectDetail from './pages/ProjectDetail';
import EditProject from './pages/admin/EditProject';
import AdminMessages from './pages/admin/AdminMessages';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AddMember from './pages/admin/AddMember';
import EditMember from './pages/admin/EditMember';
import AddResources from './pages/admin/AddResources';
import EditResources from './pages/admin/EditResources';
import EditTeamImage from './pages/admin/EditTeamImage';
import AddProjectGroup from './pages/admin/AddProjectGroup';
import EditProjectGroup from './pages/admin/EditProjectGroup';
import EditQuantClub from './pages/admin/EditQuantClub';
import RecruitmentSettings from './pages/admin/RecruitmentSettings';
import Join from './pages/Join';
import PrivacyDialog from './components/PrivacyDialog';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProjectGroups from './pages/ProjectGroups';

import './App.css';
import './styles/main.css';

// Component to handle privacy dialog logic
function AppContent() {
  const [message, setMessage] = useState('');
  const [showPrivacy, setShowPrivacy] = useState(() => {
    return !localStorage.getItem('privacyAccepted');
  });
  const location = useLocation();

  useEffect(() => {
    // Disable browser scroll restoration completely
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/hello`)
      .then(res => res.json())
      .then(data => setMessage(data.message))
      .catch(err => console.error('Error fetching message:', err));
  }, []);

  // Add useEffect to check localStorage on location changes
  useEffect(() => {
    const privacyAccepted = localStorage.getItem('privacyAccepted');
    setShowPrivacy(!privacyAccepted);
  }, [location.pathname]);

  const handleAcceptPrivacy = () => {
    localStorage.setItem('privacyAccepted', 'true');
    setShowPrivacy(false);
  };

  const handleDeclinePrivacy = () => {
    localStorage.setItem('privacyAccepted', 'declined');
    setShowPrivacy(false);
  };

  // Don't show privacy dialog on privacy policy page
  const shouldShowPrivacy = showPrivacy && location.pathname !== '/privacy-policy';

  return (
    <div className="App">
      <Navbar />
      <div className="App-main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/team" element={<Team />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/admin/add-project" element={<AddProject />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/quant-club" element={<QuantClub />} />
          <Route path="/join" element={<Join />} />
          <Route path="/admin/resources/add" element={<AddResources />} />
          <Route path="/admin/resources/edit" element={<EditResources />} />
          <Route path="/contact" element={<Contact message={message} />} />
          <Route path="/projects/:name" element={<ProjectDetail />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/add-project" element={<AddProject />} />
          <Route path="/admin/edit-project" element={<EditProject />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/admin/add-member" element={<AddMember />} />
          <Route path="/admin/edit-member" element={<EditMember />} />
          <Route path="/admin/edit-team-image" element={<EditTeamImage />} />
          <Route path="/admin/project-groups/add" element={<AddProjectGroup />} />
          <Route path="/admin/project-groups/edit" element={<EditProjectGroup />} />
          <Route path="/admin/quant-club/edit" element={<EditQuantClub />} />
          <Route path="/admin/recruitment" element={<RecruitmentSettings />} />
          <Route path="/project-groups/:groupName" element={<ProjectGroups />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
      <Footer />
      <PrivacyDialog open={shouldShowPrivacy} onAccept={handleAcceptPrivacy} onDecline={handleDeclinePrivacy} />
    </div>
  );
}


function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;